export default "__VITE_ASSET__b07d6121__"